import { Mark } from '@tiptap/core'

/**
 * Minimal comment mark definition for static rendering.
 * This is used to prevent errors when rendering documents with comment marks to markdown.
 * The actual comment functionality is not needed for static rendering.
 */
export const CommentMarkStub = Mark.create({
  name: 'comment',
  
  parseHTML() {
    return [
      {
        tag: 'mark[data-comment]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['mark', { ...HTMLAttributes, 'data-comment': '' }, 0]
  },

  addAttributes() {
    return {
      commentId: {
        default: null,
      },
      user: {
        default: null,
      },
      content: {
        default: null,
      },
      createdAt: {
        default: null,
      },
      status: {
        default: null,
      },
      scope: {
        default: null,
      },
      blockId: {
        default: null,
      },
      pageSection: {
        default: null,
      },
    }
  },
})